import * as Yup from 'yup';
//utils
import {emailSchema} from '@/utils/validation';
import { ITeamUpdateData } from '@/utils/types';

export interface EditTeamMemberFormValues {
  firstName: string;
  lastName: string;
  email: string;
  logo: string| null;
}

export const editInitialValues: Omit< ITeamUpdateData, 'id' > = {
  firstName: '',
  lastName: '',
  email: '',
  logo: '',
};

export const editValidationSchema = Yup.object().shape({
  firstName: Yup.string().trim().required('First name is required'),
  lastName: Yup.string().trim().required('Last Name name is required'),
  email: emailSchema,
  logo: Yup.string().trim(),
});
